export const pt = {
  // Header
  header: {
    downloadCV: 'Baixar CV',
  },

  // Banner
  banner: {
    iAm: 'Eu sou',
    location: 'Rodrigo, 21 anos, Florianópolis-SC',
    contactButton: 'Entre em Contato',
    portfolioButton: 'Meu Portfólio',
    typewriter: {
      fullstack: 'Desenvolvedor FullStack',
      react: 'Desenvolvedor React',
      shopify: 'Desenvolvedor Shopify',
      designer: 'UI/UX Designer',
    },
  },

  // About
  about: {
    title: 'Sobre Mim',
    subtitle: 'Eu sou um Desenvolvedor FullStack',
    description: `Sou Desenvolvedor Full Stack, formado em Análise e Desenvolvimento de Sistemas, com experiência no desenvolvimento de plataformas web, e-commerces e sistemas SaaS.

Minha trajetória profissional começou no universo criativo, atuando como Designer Gráfico, Editor de Vídeo e Filmmaker, o que me proporcionou uma base sólida em design, usabilidade e experiência do usuário. Com o tempo, encontrei na programação o equilíbrio entre criatividade e lógica, área na qual atuo profissionalmente desde 2023.

Atuei como primeiro desenvolvedor full-time de uma startup de saúde, sendo responsável por construir a plataforma do zero, participando de decisões de arquitetura, integrações com APIs e desenvolvimento de funcionalidades com Inteligência Artificial voltadas ao apoio médico.

Também possuo experiência com e-commerces e sistemas internos, especialmente no ecossistema Shopify, trabalhando com Liquid, GraphQL e APIs, além de manutenção e desenvolvimento de aplicações com React, Ruby on Rails, Node.js e PHP.

Tenho maior afinidade com Front-End, criando interfaces intuitivas e performáticas, mas atuo de forma completa no Back-End, sempre focado em soluções escaláveis, bem estruturadas e orientadas ao negócio.`,
    stats: {
      months: 'Meses',
      workExperience: 'Experiência de Trabalho',
      servicesCompleted: 'Serviços e projetos Concluidos',
      coursesCompleted: 'Cursos Concluidos',
    },
    contactButton: 'Entre em Contato',
    portfolioButton: 'Meu Portfólio',
  },

  // WorksText (Experiences)
  worksText: {
    title: 'Minhas Experiências',
    technologies: 'Tecnologias:',
    experiences: [
      {
        id: 1,
        company: 'HealthTracker',
        period: '02/2025 a 12/2025',
        role: 'Desenvolvedor Fullstack (PJ)',
        description: [
          'Desenvolvimento de Plataforma de Saúde (Startup HealthTracker)',
          'Atuei como primeiro desenvolvedor full-time, responsável por construir a plataforma do zero.',
          'Desenvolvimento de soluções com Inteligência Artificial para apoiar médicos na análise de exames.',
          'Arquitetura e implementação de funcionalidades utilizando Ruby on Rails, React, JavaScript e REST APIs.',
          'Criação de um sistema robusto, escalável e intuitivo, garantindo usabilidade para diferentes perfis de usuários:',
          '• Médico: acesso completo à gestão de pacientes e exames e chat com IA.',
          '• Paciente: envio e acompanhamento de exames pela plataforma.',
          '• Médico convidado (guest): acesso restrito para visualização de pacientes compartilhados.',
          '• Colaborador (secretária): painel administrativo com permissões controladas.',
          'Landing Page HealthTracker - Desenvolvimento e publicação da landing page institucional da HealthTracker. Utilização de WordPress para construção rápida, responsiva e otimizada para conversão.',
        ],
        technologies: 'Ruby on Rails, React, JavaScript, REST APIs, WordPress',
      },
      {
        id: 2,
        company: 'HigiePro',
        period: '04/2024 a 12/2024',
        role: 'Desenvolvedor Fullstack',
        description: [
          'Empresa HIGIEPRO COMÉRCIO DE PRODUTOS DE HIGIENE PROFISSIONAL.',
          'Projeto Seller Portal: Construção de um Seller Portal no Retool, usando GraphQL para transformar dados da Shopify em gráficos e relatórios interativos, também criado funcionalidade para controle de estoque dos Sellers, para que as entregas fossem mais rápidas diminuindo de até 30 dias para entrega, para até 14 dias.',
          'Projeto E-commerce - Site: Criada loja da Prosupply, uma vertente da Higiepro, para venda de produtos, desenvolvimento de features faltantes na shopify.',
          'Projeto Loja.Higiepro e Higiepro - Manutenção de site: Manutenção de ambos sites que foram feitos com Php e Laravel.',
        ],
        technologies: 'GraphQL, Liquid (Shopify), TypeScript, JavaScript, Shopify REST API, Shopify GraphQL API, ReactJs, Node.js, PHP, Laravel, HTML, CSS',
      },
      {
        id: 3,
        company: 'Vista Software',
        period: '07/2023 a 04/2024',
        role: 'Analista de Suporte',
        description: [
          'Empresa de tecnologia da informação focada no desenvolvimento de software, sites, que opera em diversos negócios imobiliários.',
          'Customização avançada de temas e layouts em sites imobiliários.',
          'Solução de problemas de integração de APIs e sincronização com sistemas externos.',
          'Criação e configuração de e-mails institucionais.',
          'Implantação e gerenciamento de sites, desde o ambiente de hospedagem até a entrega final.',
        ],
        technologies: 'WordPress, PHP, MySQL, JavaScript, REST API, HTML, CSS',
      },
      {
        id: 4,
        company: 'Floripa Moto Week',
        period: '09/2022 a 12/2024',
        role: 'Desenvolvedor Full Stack - Freelancer oficial do evento',
        description: [
          'Floripa Moto Week é um dos maiores eventos de moto do estado de SC.',
          'Projeto site v1 (2023): Criado site para o Floripa Moto Week, com intuito de acrescentar leads, e gerar mais faturamento.',
          'Projeto site v2 (2024): Foi criado um site com integração de pagamentos próprios, com intuito de acrescentar leads, e gerar mais ingressos vendidos.',
        ],
        technologies: 'WordPress, Elementor, PHP, MySQL, Next.js, ReactJs, Node, PostgreSQL, Prisma (ORM), TypeScript, TailWindCSS, Shadcn',
      },
    ],
  },

  // Work
  work: {
    title: 'Meus Últimos Trabalhos.',
    seeAllProjects: 'Veja todos projetos no GitHub.',
    seeProject: 'Veja o Projeto.',
    repository: 'Repositório.',
    projects: [
      {
        description: 'Feito com WORDPRESS, ELEMENTOR, FIGMA, PHOTOSHOP.\nSite para o evento de motos realizado desde 2023 em Florianópolis\n\nSite desativado por Flavio, retorna na proxima edição!',
      },
      {
        description: 'Feito com ReactJs/NextJs/React Native\nEstou desenvolvendo uma aplicação para agendamento de salões de beleza, ou de outros nichos.',
      },
      {
        description: 'Feito com LIQUID, JavaScript, HTML.\nDesenvolvi um template para HIGIEPRO utilizar como modelos de LandingPage para seus produtos.',
      },
    ],
  },

  // Work2
  work2: {
    projects: [
      {
        description: 'Feito com WORDPRESS, ELEMENTOR, FIGMA, Photoshop.\nSite feito para Advocacia Schappo, me pediu para fugir dos padrões dos templates de ADVOCACIAS.\n\nSITE DESCONTINUADO, CLIENTE PEDIU PARA PARAR DE FAZER MANUTENÇÃO.',
      },
      {
        description: 'Feito com LIQUID, JavaScript\nLoja Virtual, feita com a SHOPIFY, para a PROSUPPLY, que pertence a HIGIEPRO, foi utilizado base do template TRADE, com personalizações feita por mim, diretamente no codigo.',
        seeProject: 'Veja o Projeto.',
        repository: 'Repositório.',
      },
      {
        description: 'Feito com WORDPRESS, ELEMENTOR, FIGMA, Photoshop.\nLanding Page feita para o evento ENCATHO, esta LandingPage terá sua segunda versão liberada no dia do evento',
        repository: 'Repositório.',
      },
      {
        description: 'Feito com, LARAVEL, PHP, HTML, JavaScript\nDou suporte a algumas demandas relacionadas a este site, foi refeita toda a home.',
        seeProject: 'Veja o Projeto.',
      },
    ],
  },

  // Services
  services: {
    title: 'Meus cursos!',
    subtitle: 'aqui deixarei listado os principais:',
    seeWorks: 'Veja meus trabalhos.',
    courses: [
      {
        name: 'Analise e Desenvolvimento de Sistemas.',
        description: 'Instituição: Descomplica, Inicio: Agosto/2k23 Previsão de término: 2k25.',
      },
      {
        name: 'Curso JavaScript Completo',
        description: 'Instituição: Danki Code, Carga Horária: 14 horas.',
      },
      {
        name: 'Curso FrontEnd Completo',
        description: 'Instituição: Danki Code, Carga Horária: 81 horas.',
      },
      {
        name: 'Curso FontEnd Completo 2.0',
        description: 'Instituição: Danki Code, Carga Horária: 10 horas.',
      },
      {
        name: 'Curso JavaScript Curso Em Video',
        description: 'Instituição: Curso Em Video, Carga Horária: 40 horas.',
      },
    ],
  },

  // Contact
  contact: {
    subtitle: 'Minhas Redes Sociais!',
    title: 'Entre em Contato.',
  },
};

